'use client';

import { AppImageClient, AppImageData } from '@components/appImage';
import { Carousel } from '@components/carousel';
import { LazyVideo } from '@components/lazyVideo';

import { useResize } from '@/shared/hooks/useResize';

interface NavigatorCardsCarouselProps {
  navigatorCards: {
    imageData?: AppImageData;
    videoSrc?: string;
    posterSrc?: string;
    description: string;
    alt?: string;
  }[];
}

export const NavigatorCardsCarousel = ({
  navigatorCards,
}: NavigatorCardsCarouselProps) => {
  const { isScreenSm } = useResize();

  return (
    <div className="m-auto w-[302px] sm:w-[616px]">
      <Carousel
        loop
        countSlider={isScreenSm ? 1 : 2}
        pagination={true}
        countSlidesPerGroup={isScreenSm ? 1 : 2}
        spaceBetweenSlides={12}
        loopAddBlankSlides={false}
      >
        {navigatorCards.map(
          ({ imageData, description, videoSrc, posterSrc, alt }, index) => (
            <Carousel.Item key={index}>
              <div
                className="rounded-20 h-[351px] p-2 max-sm:h-[364px] max-sm:w-[302px]"
                style={{
                  background:
                    'linear-gradient(rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0))',
                }}
              >
                <div className="rounded-20 mb-3 h-[172px] overflow-clip">
                  {imageData ? (
                    <AppImageClient {...imageData} alt={alt || ''} />
                  ) : (
                    videoSrc && (
                      <LazyVideo
                        className="h-full w-full object-cover"
                        src={videoSrc}
                        poster={posterSrc}
                      />
                    )
                  )}
                </div>
                <span
                  dangerouslySetInnerHTML={{ __html: description }}
                  className="block px-3 text-sm leading-[18px]"
                />
              </div>
            </Carousel.Item>
          ),
        )}
      </Carousel>
    </div>
  );
};
